import { createMuiTheme } from '@zn-material-ui'

export default createMuiTheme({
  props: {
    MuiList: {
      style: {
        padding: '0px',
      },
    },
    MuiListItem: {
      alignItems: 'flex-start',
      style: {
        paddingLeft: '20px',
        paddingTop: '20px',
        paddingBottom: '20px',
        cursor: 'pointer',
      },
    },
    MuiCard: {
      elevation: 0,
    },
  },
  palette: {
    primary: {
      main: '#FA534A',
    },
    secondary: {
      main: '#fff',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
    action: {
      hover: '#FF2C2C',
      selected: '#DD2525',
      active: '#DD2525',
      disabled: 'rgba(250,83, 74, 0.5)',
    },
  },
  typography: {
    fontFamily: `${[
      'Arial',
      'Hiragino Sans GB',
      'PingFang SC',
      'Microsoft YaHei',
      'Helvetica',
      'Helvetica Neue',
      'Tahoma',
      'sans-serif',
    ].join(',')} !important`,
    allVariants: {
      color: '#333333',
    },
  },
  zIndex: {
    appBar: 999,
  },
  one_login_width: 65,
  content_box_width: 1200,
  live_gradient_color: 'linear-gradient(-270deg, #FF627B 0%, #FA534A 100%)',
})
